<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.PROFILE.OPEN"
    :handler="() => $refs.modal.show()"
  />
  <DialogComponent ref="modal" type="fullscreen" hideCloseButton noInnerPadding>
    <div class="h-full flex flex-col overflow-auto">
      <div class="p-5">
        <FullScreenDialogHeader @backClicked="() => $refs.modal.hide()">
          Profile
        </FullScreenDialogHeader>
      </div>

     <ProfilePageContent/>

      <!-- Help Section -->
    </div>
  </DialogComponent>
</template>
